import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import expireReducer from 'redux-persist-expire';
import storage from 'redux-persist/lib/storage';

import { reducer as navigationReducer } from 'src/slices/navigation';
import { reducer as fileReducer } from 'src/slices/file';
import { reducer as tableReducer } from 'src/slices/table';
import { reducer as copiedFormDataReducer } from 'src/slices/copiedFormData';

const navigationPersistConfig = {
  key: 'navigation',
  storage: storage,
  transforms: [
    expireReducer('tabs', {
      expireSeconds: 86400,
      expiredState: {
        mdfAdmissionRequestSummaryDetail: 0,
        carryRequestSummaryDetail: 0,
        admissionPersonDetails: 0,
        authGroupDetails: 0
      },
      autoExpire: true
    })
  ]
};

const tablePersistConfig = {
  key: 'table',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  transforms: [
    expireReducer('filter', {
      expireSeconds: 86400,
      expiredState: {
        authGroup: { items: [], quickFilterValues: [] },
        admissionPerson: { items: [], quickFilterValues: [] },
        carryRequest: { items: [], quickFilterValues: [] },
        mdfAdmissionRequest: { items: [], quickFilterValues: [] },
        admissionHistory: { items: [], quickFilterValues: [] },
        contact: { items: [], quickFilterValues: [] },
        contactsAdmissionPerson: { items: [], quickFilterValues: [] }
      },
      autoExpire: true
    }),
    expireReducer('pagination', {
      expireSeconds: 86400,
      expiredState: {
        authGroup: {},
        admissionPerson: {},
        carryRequest: {},
        mdfAdmissionRequest: {},
        admissionHistory: {},
        contact: {},
        contactsAdmissionPerson: {}
      },
      autoExpire: true
    }),
    expireReducer('sort', {
      expireSeconds: 86400,
      expiredState: {
        authGroup: [],
        admissionPerson: [],
        carryRequest: [],
        mdfAdmissionRequest: [],
        admissionHistory: [],
        contact: [],
        contactsAdmissionPerson: []
      },
      autoExpire: true
    })
  ]
};

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    navigation: persistReducer(navigationPersistConfig, navigationReducer),
    table: persistReducer(tablePersistConfig, tableReducer),
    file: fileReducer,
    copiedFormData: copiedFormDataReducer
  });

export default rootReducer;
